import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';
import CompanyModal from './CompanyModal';

const Footer = () => {
  const { t } = useLanguage();
  const [showCompanyModal, setShowCompanyModal] = useState(false);

  return (
    <>
      <footer className="bg-secondary-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo and description */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <Logo size="sm" />
                <span className="text-xl font-bold font-display">BIZREP</span>
              </div>
              <p className="text-secondary-300 mb-4 max-w-md">
                {t('footerDescription')}
              </p>
              <div className="text-sm text-secondary-400">
                <p>{t('copyright')}</p>
                <p className="mt-1">
                  {t('developedBy')}{' '}
                  <button
                    onClick={() => setShowCompanyModal(true)}
                    className="text-primary-400 hover:text-primary-300 underline transition-colors"
                  >
                    M42 Orion
                  </button>
                  {' '}• CNPJ: 53.542.960/0001-40
                </p>
              </div>
            </div>

            {/* Product Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">{t('product')}</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/#features" className="text-secondary-300 hover:text-white transition-colors">
                    {t('features')}
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="text-secondary-300 hover:text-white transition-colors">
                    {t('pricing')}
                  </Link>
                </li>
                <li>
                  <Link to="/#how-it-works" className="text-secondary-300 hover:text-white transition-colors">
                    {t('howItWorks')}
                  </Link>
                </li>
                <li>
                  <Link to="/register" className="text-secondary-300 hover:text-white transition-colors">
                    {t('freeTrial')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Support Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">{t('support')}</h3>
              <ul className="space-y-2">
                <li>
                  <a 
                    href="mailto:support@bizrep.ai" 
                    className="text-secondary-300 hover:text-white transition-colors"
                  >
                    {t('contact')}
                  </a>
                </li>
                <li>
                  <a 
                    href="https://help.bizrep.ai" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-secondary-300 hover:text-white transition-colors"
                  >
                    {t('helpCenter')}
                  </a>
                </li>
                <li>
                  <Link to="/terms" className="text-secondary-300 hover:text-white transition-colors">
                    {t('termsOfUse')}
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-secondary-300 hover:text-white transition-colors">
                    {t('privacyPolicy')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom section */}
          <div className="border-t border-secondary-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-secondary-400 mb-4 md:mb-0">
              <p>M42 - Orion Assessoria LTDA</p>
              <p>Av. Hilário Pereira de Souza, 492 - Sala 3003 - Osasco/SP</p>
            </div>
            
            <div className="flex space-x-6">
              <a 
                href="https://linkedin.com/company/bizrep" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-400 hover:text-white transition-colors"
              >
                LinkedIn
              </a>
              <a 
                href="https://twitter.com/bizrep" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-400 hover:text-white transition-colors"
              >
                Twitter
              </a>
              <a 
                href="https://instagram.com/bizrep" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-400 hover:text-white transition-colors"
              >
                Instagram
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Company Modal */}
      <CompanyModal 
        isOpen={showCompanyModal} 
        onClose={() => setShowCompanyModal(false)} 
      />
    </>
  );
};

export default Footer;

